export default __webpack_public_path__ + "static/card-image-1-078cead429ba96e494059acf5db1a3bb.png";